import { z } from 'zod';

import { ErrorResponse } from './common.js';

export const QuerySchema = z.object({
  platform: z.string(),
  connectionId: z.string().optional(),
});

export const AdAccountSchema = z.object({
  id: z.string(),
  name: z.string(),
  externalAccountId: z.string(),
  externalAccountName: z.string(),
  currency: z.string(),
  usingInCampaigns: z.boolean(),
  connectionId: z.string(),
  status: z.string().optional(),
});

export const AdAccountDeleteSchema = z.object({
  adAccountIds: z.array(z.string()),
});

export const AdAccountsResponseDataSchema = z.object({
  data: z.object({
    items: z.array(AdAccountSchema),
  }),
  error: ErrorResponse.optional(),
});

export const CreatedAdAccountResponseSchema = z.object({
  data: z.object({
    items: z.array(
      z.object({
        createdAccounts: z.array(AdAccountSchema),
      }),
    ),
  }),
  error: ErrorResponse.optional(),
});

export const AdAccountVerifyResponseSchema = z.object({
  data: z.object({
    items: z.array(z.object({ verified: z.boolean() })),
  }),
  error: ErrorResponse.optional(),
});

export const CreateAccountRequestSchema = z.object({
  connectionId: z.string(), //TODO request BE team to change in API
  adAccounts: z.array(
    z.object({
      externalAccountId: z.string(),
      adAccountName: z.string(),
    }),
  ),
});
